import { Box, Flex, Text } from '@modusign/design-system';

interface TabProps {
  tabs: string[];
  selectedTabIndex: number;
  onTabChange: (tabIndex: number) => void;
}

export default function Tab({ tabs, selectedTabIndex, onTabChange }: TabProps) {
  return (
    <Flex>
      {tabs.map((tab, index) => (
        <Text
          as="button"
          color={tab === 'list' ? 'textNeutralBase' : 'textNeutralSlightlyLight'}
          fontWeight={index === selectedTabIndex ? 'bold' : undefined}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          px={7}
          py={4}
          sx={{
            borderColor:
              index === selectedTabIndex ? 'navigationBorderPrimaryUltraLight' : 'transparent',
            borderBottomColor:
              index === selectedTabIndex ? 'transparent' : 'navigationBorderPrimaryUltraLight',
            borderWidth: '1px',
            borderStyle: 'solid',
            width: ['50%', undefined, 'auto'],
          }}
          onClick={() => onTabChange(index)}
        >
          {tab}
        </Text>
      ))}
      <Box
        borderColor="navigationBorderPrimaryUltraLight"
        borderStyle="solid"
        borderWidth="0 0 1px 0"
        flex="1"
      />
    </Flex>
  );
}
